import { Injectable } from '@angular/core';
import {
    EmailPreferences,
    EmailPreferencesUpdate
} from '../../core-data-model/CompanySettings.model';
import { ApiService } from '../../system-services/Api.service';
import { UserProfileSettingsService } from '../../system-services/UserProfileSettings/UserProfileSettings.service';
import { GeneralSettingsApiTransformer } from './GeneralSettingsApi.datatransform';

@Injectable({
    providedIn: 'root'
})
export class GeneralSettingsApi {
    constructor(
        private api: ApiService,
        private userProfile: UserProfileSettingsService,
        private transformer: GeneralSettingsApiTransformer
    ) {}

    getEmailSetttings(
        companyId: string = this.userProfile.currentCompany
    ): Promise<EmailPreferences> {
        return this.api
            .get<any>(`/api/v3/companies/${companyId}/generalsetting`)
            .then(([response]) =>
                this.transformer.transformServerToClient(response)
            );
    }

    updateEmailSettings(
        emailSettingUpdate: EmailPreferencesUpdate,
        companyId: string = this.userProfile.currentCompany
    ) {
        return this.api
            .patch(
                `/api/v3/companies/${companyId}/generalsetting`,
                this.transformer.transformClientToServer(emailSettingUpdate)
            )
            .then(([response]) =>
                this.transformer.transformServerToClient(response)
            );
    }
}
